// extracted by mini-css-extract-plugin
module.exports = {"container":"Layout-module--container--2h5A0","prices":"Layout-module--prices--1BlVZ"};